<div class="form-group" *ngIf="(this.transactionInfo.isTravelPersonal() || this.transactionInfo.isAccidentProduct() || this.isPaynowForGeneric()) && claim.getPolicyHolderType().toLowerCase()!=='c'">
    <qnect-ui #PAYNOW_OPTION [fieldId]="'PAYNOW_OPTION'" [formGroup]="payNowForm" name="payNowOption"></qnect-ui>
</div>
<div class="form-group" *ngIf="claim.getProxyIdType()==='NRIC/FIN'  && claim.getPolicyHolderType().toLowerCase()!=='c'">
    <qnect-ui #PAYNOW_CLAIMANT [fieldId]="'PAYNOW_CLAIMANT'" [formGroup]="payNowForm" name="payNowClaimant"
        [dynamicOptions]="claimantOptions" (change)="claimantChange($event)"></qnect-ui>
    <qnect-ui #PAYNOW_CLAIMANT_ID [fieldId]="'PAYNOW_CLAIMANT_ID'" [formGroup]="payNowForm"
        name="payNowClaimantId" [disabled]="true"></qnect-ui>
</div>

<ng-container>
    <div class="form-group" *ngIf="this.transactionInfo.isValidCorporateClient(this.claim.getPolicyHolderId())">
        <qnect-ui #PAYNOW_UEN_OPTION [fieldId]="'PAYNOW_UEN_OPTION'" [formGroup]="payNowForm"
            name="payNowOption"></qnect-ui>
        <qnect-ui #PAYNOW_UEN_NAME_TXT [fieldId]="'PAYNOW_UEN_NAME_TXT'" [formGroup]="payNowForm"
            name="payNowClaimantUENName"></qnect-ui>
        <qnect-ui #PAYNOW_UEN_ID_TXT [fieldId]="'PAYNOW_UEN_ID_TXT'" [formGroup]="payNowForm"
            name="payNowClaimantUENId"></qnect-ui>
    </div>
    <div class="form-group" *ngIf="this.claim.getPolicyHolderType().toLowerCase()==='c' && !this.transactionInfo.isGenericClaim()">
        <qnect-ui #PAYNOW_NRIC_OPTION [fieldId]="'PAYNOW_NRIC_OPTION'" [formGroup]="payNowForm"
            name="payNowOption"></qnect-ui>
        <qnect-ui #PAYNOW_NRIC_NAME_TXT [fieldId]="'PAYNOW_NRIC_NAME_TXT'" [formGroup]="payNowForm"
            name="payNowClaimantNRICName"></qnect-ui>

        <qnect-ui #PAYNOW_NRIC_ID_TXT [fieldId]="'PAYNOW_NRIC_ID_TXT'" [formGroup]="payNowForm"
            name="payNowClaimantNRICId"></qnect-ui>
    </div>
</ng-container>
<div class="info-box">
    <div class="info-content">
        <i class="info-hits"></i>
        <div class="info-text">
            <p class="info-title">{{'pagePaymentAndContact.paynow.infoTitle' | translate}}</p>
            <p class="info-message">{{'pagePaymentAndContact.paynow.infoMessage' | translate}}</p>
        </div>
    </div>
</div>